<template lang="pug">
  
  .administration(:class="classObject"): .content: .client {{ $t('task.administration') }}

</template>

<script>
import cellable from './mixins/cellable'

export default{
  mixins: [cellable],
}
</script>